import { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { CustomDataTable } from "./Tables/CustomDataTable";
import "../theme/HorariosView.css";
import { icons } from "../const/icons";

/**
 * Transforma data de horarios a la representa empleando CustomDataTable
 */
export const ListaEmpleadosHoras = ({ horarios, entrada, salida, isLoading, searchTerm }) => {
  const PATRON_HORARIO = /^\d{2}:\d{2}$/;
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const columns = useMemo(() => {
    const entradaCol = entrada;
    const salidaCol = salida;

    return [
      {
        title: (
          <div className="header-icon-container">
            <img src={icons.empleados} alt="Empleados" className="header-icon-empleados" />
            Empleados
          </div>
        ),
        dataIndex: "fc_nombre_empleado",
        key: "empleado",
        width: "40%",
        render: (nombre, record) => (
          <div className="item-name-list-data">
            <div className="item-name-list">{nombre}</div>
            <div className="item-puesto-list">{record.fc_nombre_puesto}</div>
          </div>
        ),
        sorter: (a, b) => a.fc_nombre_empleado.localeCompare(b.fc_nombre_empleado),
      },
      {
        title: "Entrada",
        key: "entrada",
        width: "30%",
        align: "center",
        render: (_, record) => {
          const entradaValue = record[entradaCol];

          // Horario válido (HH:mm)
          if (PATRON_HORARIO.test(entradaValue)) {
            return <div className="item-number-hora-verde">{entradaValue}</div>;
          }

          // Descripcion
          return <div className="item-number-text">{entradaValue}</div>;
        },
      },
      {
        title: "Salida",
        key: "salida",
        width: "30%",
        align: "center",
        render: (_, record) => {
          const entradaValue = record[entradaCol];
          const salidaValue = record[salidaCol];

          // Solo mostrar salida si entrada es horario válido
          if (PATRON_HORARIO.test(entradaValue)) {
            return <div className="item-number-hora-verde">{salidaValue}</div>;
          }

          // ocultar esta celda
          return null;
        },
      },
    ];
  }, [entrada, salida]);

  const filteredData = useMemo(() => {
    if (!searchTerm?.trim()) return horarios;

    const term = searchTerm.toUpperCase();
    return horarios.filter((item) => item.fc_nombre_empleado?.toUpperCase().includes(term));
  }, [horarios, searchTerm]);

  // Generar IDs únicos para cada registro
  const dataWithIds = useMemo(
    () =>
      filteredData.map((item, idx) => ({
        ...item,
        id: `${item.fc_nombre_empleado}-${idx}`,
      })),
    [filteredData]
  );

  // Paginación del lado del cliente
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return dataWithIds.slice(startIndex, endIndex);
  }, [dataWithIds, currentPage, pageSize]);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  return (
    <div>
      <CustomDataTable
        data={paginatedData}
        columns={columns}
        loading={isLoading}
        showPagination={true}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: dataWithIds.length,
        }}
        onPageChange={handlePageChange}
        emptyText="No hay datos para mostrar"
        className="horarios-table"
      />
    </div>
  );
};

ListaEmpleadosHoras.propTypes = {
  horarios: PropTypes.array.isRequired,
  entrada: PropTypes.string.isRequired,
  salida: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  searchTerm: PropTypes.string,
};
